import { PageHeader } from '../../../components/layout/Header';
import { Button } from '../../../components/ui';
import { Alert, AlertDescription, AlertTitle } from '../../../components/ui/alert';
import DateRangePicker from '../../../components/shared/filters/DateRangePicker';
import { useAdminStats } from '../hooks/useAdminStats';
import { DashboardKpiRow } from './DashboardKpiRow';
import { AccountTypeSection } from './AccountTypeSection';
import { RecurrenceSection } from './RecurrenceSection';
import { ChurnEvolutionSection } from './ChurnEvolutionSection';
import { DashboardSkeleton } from './DashboardSkeleton';

export function AdminDashboardPage() {
  const { data, isLoading, error, refetch, dateRange, setDateRange } = useAdminStats();

  return (
    <div className="flex flex-col bg-background">
      <PageHeader
        title="Dashboard"
        subtitle="Visão da plataforma · clientes, trial e churn"
        titleClassName="text-xl font-semibold tracking-tight text-default"
        subtitleClassName="text-[13px] text-muted"
        className="mb-[18px]"
        hideBackButton
      />

      <div className="mb-s4 flex flex-col gap-s2 sm:flex-row sm:items-center sm:justify-end">
        <DateRangePicker value={dateRange} onChange={setDateRange} />
      </div>

      {isLoading && <DashboardSkeleton />}

      {!isLoading && error && (
        <Alert variant="destructive">
          <AlertTitle>Erro ao carregar</AlertTitle>
          <AlertDescription className="flex flex-col gap-s3">
            <p>{error}</p>
            <Button variant="outline" size="sm" onClick={() => void refetch()}>
              Tentar novamente
            </Button>
          </AlertDescription>
        </Alert>
      )}

      {!isLoading && !error && data && (
        <>
          <DashboardKpiRow kpis={data.kpis} />
          <AccountTypeSection rows={data.accountTypes} />
          <RecurrenceSection rows={data.recurrence} />
          <ChurnEvolutionSection churn={data.churnEvolution} />
        </>
      )}
    </div>
  );
}
